import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["href", "variant", "src", "alt", "isHeaderLogo", "useNextImage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Link, useBreakpointValue } from '@chakra-ui/react';
import { formatAssetsUrl } from '@whitbread-eos/utils';
import { LogoHub, LogoHubSimple, LogoPi, LogoPiIcon, LogoPiSimple, LogoZip, LogoZipSimple } from '../../assets/icons';
import Icon from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Logo(_ref) {
  var href = _ref.href,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'pi' : _ref$variant,
    src = _ref.src,
    alt = _ref.alt,
    isHeaderLogo = _ref.isHeaderLogo,
    useNextImage = _ref.useNextImage,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var svgMapper = {
    pi: _jsx(LogoPi, {}),
    pid: _jsx(LogoPi, {}),
    'pi-simple': _jsx(LogoPiSimple, {}),
    'pid-simple': _jsx(LogoPiIcon, {}),
    'pi-icon': _jsx(LogoPiIcon, {}),
    hub: isHeaderLogo ? _jsx(LogoHub, {}) : _jsx(Icon, _objectSpread({
      alt: alt,
      src: src && formatAssetsUrl(src),
      useNextImage: useNextImage
    }, iconLogoHubStyle)),
    'hub-simple': _jsx(LogoHubSimple, {}),
    zip: _jsx(LogoZip, {}),
    'zip-simple': _jsx(LogoZipSimple, {})
  };
  var resolution = useBreakpointValue({
    mobile: 'smallResolution',
    sm: 'bigResolution'
  });
  return _jsx(Box, {
    "data-testid": "logo-container-".concat(variant),
    transform: otherProps.transform ? otherProps.transform : {
      mobile: 'scale(0.667)',
      sm: 'scale(0.833)',
      lg: 'scale(1)'
    },
    children: href ? _jsx(Link, {
      "data-testid": "logo-test-id",
      href: href,
      _focus: {
        boxShadow: 'none'
      },
      children: variant !== 'hub' && variant !== 'hub-simple' && variant !== 'zip' && variant !== 'zip-simple' && resolution !== 'smallResolution' ? _jsx(Icon, {
        alt: alt,
        src: src,
        maxHeight: "var(--chakra-space-3xl)",
        maxWidth: "9.87rem",
        useNextImage: useNextImage
      }) : svgMapper[variant]
    }) : svgMapper[variant]
  });
}
var iconLogoHubStyle = {
  height: '4rem',
  width: '10.75rem'
};